import { apiDaInscricao } from "../../../servicos/axios";

export type Estado = {
  id: number;
  nome: string;
  uf: string;
};

export const buscarEstados = async (): Promise<Estado[]> => {
  const response = await apiDaInscricao().get("/Cidades/Estados");
  return response.data;
};
